import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'roundAndTrim'
})
export class RoundAndTrimPipe implements PipeTransform {

  transform(value: number, decimalPlaces: number = 5): string {
    if (value == null) return '';

    // Round the number to 5 decimal places by default
    let roundedValue = value.toFixed(decimalPlaces);

    // Trim trailing zeroes and the decimal point if necessary
    roundedValue = parseFloat(roundedValue).toString();

    return roundedValue;
  }

}
